import React, { useEffect, useState } from "react";
import UtilityHelper from "../../../service/utilities/UtilityHelper";


type Props = {
  id?: string;
  name?: string;
  rowSize?: number;
  classStyle?: string;
  placeHolder?: string;
  value?: string;
  validate?: boolean | false;
  maxWords?: number;
  error?: boolean;
  handleOnChange?: (
    fieldName: string,
    fieldValue: string,
    isValid?: boolean | true
  ) => void;
};

const TextArea: React.FC<Props> = ({
  classStyle = "",
  placeHolder = "",
  name = "",
  handleOnChange,
  rowSize = 3,
  value,
  validate = false,
  error = false,
  maxWords = undefined,
}) => {
  /* classStyle = classStyle || ``;
  rowSize = rowSize || 3;
  placeHolder = placeHolder || ``;
  id = id || name || "";
  value = value || ""; */

  const [validateStatus, setsetValidate] = useState<boolean>(true);

  let fieldName: string = "",
    fieldValue: string = "";

  const handleOnChangePush = (
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    fieldName = event.target.name.toLowerCase();
    fieldValue = event.target.value.toString();

    let errorCounter = 0;
    if (validate) {
      if (UtilityHelper.isEmpty(fieldValue)) {
        errorCounter++;
      } else {
        if (maxWords !== undefined) {
          if (UtilityHelper.countWords(fieldValue) > maxWords) {
            errorCounter++;
          }
        }
      }
    }

    setsetValidate(errorCounter === 0);

    handleOnChange?.(fieldName, fieldValue, errorCounter === 0);
  };

  const handleClick = (event: React.MouseEvent<HTMLTextAreaElement>) => {
    setsetValidate(true);
  };

  //const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {};

  useEffect(() => {
    console.log("rendered input");
  }, []);

  return (
    <div
      className={`form-group border-0 ${!validateStatus ? "error" : ""} ${
        error ? "error" : ""
      }`}
    >
      <textarea
        id={name ?? ""}
        name={name ?? ""}
        rows={rowSize}
        className={`form-control  color-theme-label ${classStyle} `}
        placeholder={placeHolder}
        value={value}
        onChange={(e) => handleOnChangePush(e)}
        onClick={(e) => handleClick(e)}
        onBlur={(e) => handleOnChangePush(e)}
      ></textarea>
    </div>
  );
};

export default TextArea;
